import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import devices from '../State/Devices';
import { IUsageSelector } from '../Types/Datasources';
import Button from './Button';
import LayoutSingleColumn from './Layout/LayoutSingleColumn';
import { Input } from './MlrForm';
import { InterfaceOption } from './Select';
import Switch from './Switch';
import Tooltip from './Tooltip';

const LayoutEditOtherColumns = styled.div`
    display: -ms-grid;
    display: grid;
    grid-template-columns: 1fr 140px;
    -ms-grid-columns: 1fr 140px;
    grid-row-gap: 8px; /* TODO */
    grid-column-gap: 8px;

    strong {
        font-size: 12px;
    }

    span {
        padding: 4px;
    }

    strong.total, span.total {
        text-align: right;
        color: ${Colours.primary};
    }
    
    & *:nth-child(2n+1) { -ms-grid-column: 1; }
    & *:nth-child(2n) { -ms-grid-column: 2; }

    & *:nth-child(1), & *:nth-child(2) { display: block; }
`;

const HeaderRow = styled.div`
    display: grid;
    grid-template-columns: 60px 1fr;
    grid-template-areas: "ItemSwitch ItemTitle"; /* TODO */
    align-items: center;
    font-weight: bold;
    margin-bottom: 16px;

    display: -ms-grid;
    -ms-grid-columns: 60px 1fr;
    -ms-grid-rows: repeat(1fr);
    & *:nth-child(2n+1) { -ms-grid-column: 1; }
    & *:nth-child(2n) { -ms-grid-column: 2; }

    /* Switch */
    label:nth-child(1) {
        grid-area: ItemSwitch;
        -ms-grid-column: 1;
    }

    /* Title */
    div:nth-child(2) {
        grid-area: ItemTitle;
        -ms-grid-column: 2;
    }

    @media ${devices.laptop} {
        grid-template-columns: 1fr 60px;
        grid-template-areas: "ItemTitle ItemSwitch";

        -ms-grid-columns: 1fr auto;
        & *:nth-child(2n+1) { -ms-grid-column: 1; }
        & *:nth-child(2n) { -ms-grid-column: 2; }
    }
`;

interface IOtherSection extends IUsageSelector {
    headers: [React.ReactNode, React.ReactNode]
    defaultOption?: InterfaceOption
    buttonAddText: string
    enabled: boolean
    labelOther: string
    onToggleEnable: () => void
    tooltip?: string
}

export default ({ 
    buttonAddText,
    enabled,
    headers,
    labelOther,
    onAddOther,
    onChangeOtherName,
    onChangeOtherValue,
    onToggleEnable,
    otherActivitySelections,
    otherCropSelections,
    otherUnlicensedSelections,
    tooltip,
    }: IOtherSection) => {
    const selections = otherUnlicensedSelections || otherCropSelections || otherActivitySelections || [];
    return (
        <div>
            <HeaderRow>
                <Switch style={{ marginRight: 8 }} checked={enabled} onChange={onToggleEnable}/>
                <div>{labelOther} {tooltip && <Tooltip text={tooltip} position="right"/>}</div>
            </HeaderRow>

            <LayoutEditOtherColumns>
                {selections.length > 0 && (
                    <React.Fragment>
                        <strong>{headers[0]}</strong>
                        <strong>{headers[1]}</strong>
                    </React.Fragment>
                )}
                {selections.map((item, index) => {
                    const onChangeOtherNameEvent = (e: React.FormEvent<HTMLInputElement>) => onChangeOtherName(index, e.currentTarget.value);
                    const onChangeOtherValueEvent = (e: React.FormEvent<HTMLInputElement>) => onChangeOtherValue(index, Number(e.currentTarget.value));
                    
                    return (
                        <React.Fragment key={index}>
                            <Input style={{ msGridRow: index + 2 }} value={item.name} type="text" placeholder="Item name" disabled={!enabled} onChange={onChangeOtherNameEvent}/>
                            <Input style={{ msGridRow: index + 2 }} value={item.value} type="number" placeholder="Total kL" disabled={!enabled} onChange={onChangeOtherValueEvent}/>
                        </React.Fragment>
                    )
                })}
            </LayoutEditOtherColumns>

            <LayoutSingleColumn>
                <Button disabled={!enabled} onClick={onAddOther}>{buttonAddText}</Button>
            </LayoutSingleColumn>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/SectionOther.tsx